import { render, staticRenderFns } from "./ServerInfo.vue?vue&type=template&id=22c61aed&scoped=true&"
import script from "./ServerInfo.vue?vue&type=script&lang=js&"
export * from "./ServerInfo.vue?vue&type=script&lang=js&"
import style0 from "./ServerInfo.vue?vue&type=style&index=0&id=22c61aed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c61aed",
  null
  
)

export default component.exports